import React from "react";
import { useStore } from "../../store";
import { LayoutRenderer } from "./LayoutRenderer";

interface SideWidgetsContainerProps {
  mainPanelSlot: React.ReactNode;
}

export const SideWidgetsContainer: React.FC<SideWidgetsContainerProps> = ({
  mainPanelSlot,
}) => {
  const { widgets, showNotifications, leftLayout, rightLayout } = useStore();

  const countForLayout = (
    layout: import("../../store/slices/uiSlice").LayoutType
  ): number => {
    switch (layout) {
      case "2-2":
        return 4;
      case "2-1":
      case "1-2":
        return 3;
      case "1-1":
        return 2;
      case "1":
        return 1;
      default:
        return 4;
    }
  };

  const leftCount = countForLayout(leftLayout);
  const rightCount = countForLayout(rightLayout);
  const leftWidgets = widgets.slice(0, leftCount);
  const rightWidgets = widgets.slice(leftCount, leftCount + rightCount);
  const dynamicLeftCount = leftWidgets.length;
  return (
    <div
      className={`flex flex-row justify-between gap-6 h-[850px] transition-all duration-300 ${
        showNotifications
          ? "-translate-x-[calc((100%-712px)/2)]"
          : "translate-x-0"
      }`}
    >
      {/* Left Side */}
      <LayoutRenderer
        layout={leftLayout}
        widgets={leftWidgets}
        baseOffset={0}
      />

      {/* Central Main Area */}
      <div className="flex flex-1 min-h-0 w-[712px]">{mainPanelSlot}</div>

      {/* Right Side */}
      <LayoutRenderer
        layout={rightLayout}
        widgets={rightWidgets}
        baseOffset={dynamicLeftCount}
      />
    </div>
  );
};
